import React from "react";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import { Container, Row } from "@/components/customComponents";
import PropTypes from "prop-types";
import { useApp } from "@next-platform/client-common-core";

// eslint-disable-next-line react/prop-types
const LinkWrapper = ({ label, url }) => {
  return (
    <>
      <LocalizedLink className="ml-[10px] no-underline text-link text-[16px] gap-[20px]" to={url} aria-label={label}>
        {label}
      </LocalizedLink>
    </>
  );
};

const PartnerFooter = () => {
  const { branding: footerConfig } = useApp();
  if (!footerConfig) return null;
  return (
    <Container justify="center" align="center" className="mt-[20px] px-6">
      <Row justify="center">
        {footerConfig.customerSupportUrl && <LinkWrapper label="Customer Support" url={footerConfig.customerSupportUrl} />}
        {footerConfig.tcUrl && <LinkWrapper label="Terms & Conditions" url={footerConfig.tcUrl} />}

        {footerConfig.privacyPolicyUrl && <LinkWrapper label="Privacy Policy" url={footerConfig.privacyPolicyUrl} />}
        {footerConfig.refundPolicyUrl && <LinkWrapper label="Refund Policy" url={footerConfig.refundPolicyUrl} />}
      </Row>
      <Row justify="center" className="id-parent text-center">
        {
          <>
            <div
              className="id w-full whitespace-nowrap"
              dangerouslySetInnerHTML={{
                __html: footerConfig?.footerBottomLineHtml,
              }}
            />
            <style>
              {`
            .id {
              width: calc(100% + 100px);
              line-height: 28px;
              letter-spacing: -0.8px;
            }
            .id a{
              color:#0072F5;
              text-decoration: none;
            }
            .dark .id a{
              color: #3694FF
            }
            @media screen and (max-width: 1900px){
              .id{
                white-space: pre-wrap;
              }
            }
          `}{" "}
            </style>
          </>
        }
      </Row>
    </Container>
  );
};

export default PartnerFooter;

PartnerFooter.propTypes = {
  footerConfig: PropTypes.object,
};
